import { createReducer, updateState } from 'redux/handlers'
import types from './types'

const initialState = {
  refreshCounter: 0
}

const updateRefreshCounter = state => updateState(state, { refreshCounter: state.refreshCounter + 1 })

const resetRefreshCounter = state => updateState(state, { refreshCounter: 0 })

export default createReducer(initialState, {
  [types.POOLS_UPDATE_REFRESH_COUNTER]: updateRefreshCounter,
  [types.POOLS_RESET_REFRESH_COUNTER]: resetRefreshCounter
})
